export const IAlert = {
    message:"",
    visibled:false
}